export default __webpack_public_path__ + "static/media/feelings_video.fa7ba0ea.mp3";